export function createReviewsCarousel(section) {
  const showcase = section.querySelector('[data-reviews-carousel]') || section;
  const controller = new AbortController();
  let observer;
  let disposed = false;
  const listen = (target, name, callback) => target.addEventListener(name, callback, { signal: controller.signal });
  var slides = Array.from(showcase.querySelectorAll('[data-showcase-slide]'));
  var logos = Array.from(showcase.querySelectorAll('[data-showcase-logo]'));
  var prev = showcase.querySelector('[data-showcase-prev]');
  var next = showcase.querySelector('[data-showcase-next]');
  var videoShell = showcase.querySelector('[data-reviews-carousel-video-shell]');
  var autoSlide = section.dataset.autoSlide === 'true';
  var speed = Number(section.dataset.slideInterval) || 5000;
  var index = 0;
  var timer = null;

  function mountVideo() {
    if (disposed || !videoShell || videoShell.dataset.videoMounted === 'true') return;

    var template = videoShell.querySelector('[data-reviews-carousel-video-template]');
    if (!template) return;

    videoShell.appendChild(template.content.cloneNode(true));
    videoShell.dataset.videoMounted = 'true';

    var video = videoShell.querySelector('video');
    if (video) {
      video.muted = true;
      video.autoplay = true;
      video.playsInline = true;
      video.play().catch(function () {});
    }
  }

  function initVideoLoading() {
    if (!videoShell) return;

    var rect = videoShell.getBoundingClientRect();
    var isNearViewport = rect.top < window.innerHeight + 600 && rect.bottom > -600;

    if (isNearViewport || !('IntersectionObserver' in window)) {
      mountVideo();
      return;
    }

    observer = new IntersectionObserver(function (entries) {
      var shouldMount = entries.some(function (entry) {
        return entry.isIntersecting;
      });

      if (!shouldMount) return;

      observer.disconnect();
      mountVideo();
    }, {
      rootMargin: '600px 0px',
      threshold: 0
    });

    observer.observe(videoShell);
  }

  initVideoLoading();



  function setActive(nextIndex) {
    if (!slides.length) return;
    index = (nextIndex + slides.length) % slides.length;

    slides.forEach(function (slide, slideIndex) {
      slide.hidden = slideIndex !== index;
    });

    logos.forEach(function (logo, logoIndex) {
      var isActive = logoIndex === index;
      logo.classList.toggle('is-active', isActive);
      logo.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function startAuto() {
    if (disposed || !autoSlide || slides.length < 2) return;
    stopAuto();
    timer = window.setInterval(function () {
      setActive(index + 1);
    }, speed);
  }

  function stopAuto() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  logos.forEach(function (logo, logoIndex) {
    listen(logo, 'click', function () {
      setActive(logoIndex);
      startAuto();
    });
  });

  if (prev) {
    listen(prev, 'click', function () {
      setActive(index - 1);
      startAuto();
    });
  }

  if (next) {
    listen(next, 'click', function () {
      setActive(index + 1);
      startAuto();
    });
  }

  listen(showcase, 'mouseenter', stopAuto);
  listen(showcase, 'mouseleave', startAuto);

  setActive(0);
  startAuto();

  return () => {
    if (disposed) return;
    disposed = true;
    stopAuto();
    controller.abort();
    observer?.disconnect();
    if (videoShell) {
      videoShell.querySelectorAll('video').forEach((video) => { video.pause(); video.remove(); });
      delete videoShell.dataset.videoMounted;
    }
  };
}

import(window.flu.chunks.befloSectionLifecycle).then(({ mountSections }) => {
  mountSections('[data-section-type="reviews-carousel"]', createReviewsCarousel);
});
